import { MapPin, Phone, Clock, Navigation, Mail } from "lucide-react";
import { Reveal } from "./Reveal";
import { CLINIC } from "@/data/content";

export default function Location() {
  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <Reveal className="max-w-2xl">
          <span className="text-xs font-semibold uppercase tracking-widest text-[#A6823B]">Locație & Program</span>
          <h2 className="font-display text-3xl lg:text-4xl font-bold text-slate-900 mt-3">Ne găsești în inima Timișoarei</h2>
        </Reveal>

        <div className="mt-12 grid lg:grid-cols-5 gap-8">
          {/* Info */}
          <Reveal className="lg:col-span-2">
            <div className="bg-[#FBF7F0] rounded-2xl border border-slate-200 p-7 h-full flex flex-col">
              <div className="flex items-start gap-3" data-testid="location-address-info">
                <span className="w-11 h-11 rounded-xl bg-[#EFE7D6] flex items-center justify-center shrink-0">
                  <MapPin className="w-5 h-5 text-[#A6823B]" />
                </span>
                <div>
                  <h4 className="font-display font-bold text-slate-900">Adresă</h4>
                  <p className="text-slate-600 mt-1">{CLINIC.address}</p>
                </div>
              </div>

              <div className="flex items-start gap-3 mt-6">
                <span className="w-11 h-11 rounded-xl bg-[#EFE7D6] flex items-center justify-center shrink-0">
                  <Clock className="w-5 h-5 text-[#A6823B]" />
                </span>
                <div>
                  <h4 className="font-display font-bold text-slate-900">Program</h4>
                  <ul className="mt-1 space-y-1">
                    {CLINIC.schedule.map((s) => (
                      <li key={s.day} className="flex justify-between gap-6 text-sm text-slate-600">
                        <span>{s.day}</span><span className="font-medium text-slate-800">{s.hours}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="flex items-start gap-3 mt-6">
                <span className="w-11 h-11 rounded-xl bg-[#EFE7D6] flex items-center justify-center shrink-0">
                  <Mail className="w-5 h-5 text-[#A6823B]" />
                </span>
                <div>
                  <h4 className="font-display font-bold text-slate-900">Email</h4>
                  <p className="text-slate-600 mt-1">{CLINIC.email}</p>
                </div>
              </div>

              <div className="mt-auto pt-7 flex flex-col sm:flex-row gap-3">
                <a href={CLINIC.phoneRaw}
                  className="flex-1 inline-flex items-center justify-center gap-2 bg-[#A6823B] hover:bg-[#8A6B2E] text-white font-semibold px-5 py-3 rounded-full transition-colors">
                  <Phone className="w-4 h-4" /> {CLINIC.phone}
                </a>
                <a href={CLINIC.mapsLink} target="_blank" rel="noopener noreferrer"
                  className="flex-1 inline-flex items-center justify-center gap-2 bg-white border border-slate-200 hover:border-[#A6823B] text-slate-800 font-semibold px-5 py-3 rounded-full transition-colors">
                  <Navigation className="w-4 h-4" /> Direcții
                </a>
              </div>
            </div>
          </Reveal>

          {/* Map */}
          <Reveal delay={0.1} className="lg:col-span-3">
            <div className="rounded-2xl overflow-hidden border border-slate-200 h-full min-h-[360px] shadow-lg shadow-slate-200/60">
              <iframe title="Hartă MEDAS Timișoara" src={CLINIC.mapEmbed}
                className="w-full h-full min-h-[360px]" loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
